import { render, staticRenderFns } from "./MyRecentlyViewed.vue?vue&type=template&id=6a035907&"
import script from "./MyRecentlyViewed.vue?vue&type=script&lang=js&"
export * from "./MyRecentlyViewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports